var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"nav-footer footer w-100 align-self-center d-print-none"},[_c('h5',{staticClass:"version-number mb-0 mx-0 text-muted text-center w-100"},[_vm._v(" "+_vm._s(_vm.appVersion)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }